export default __webpack_public_path__ + "static/media/dependent-care-fsa-guide.2f826f34.svg";